export default "__VITE_ASSET__D6IDidJ$__"